export default function setTitleText(title) {
	document.title = `${title} | ListingOpen`;
}